<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
      <FeedCard
        v-for="category in categories"
        :key="category.id"
        @click="navigateToCategory(category.mappingId, category.name)"
        @keydown.enter.prevent="
          navigateToCategory(category.mappingId, category.name)
        "
      >
        <template #icon>
          <img
            v-if="category.icon"
            :src="category.icon"
            :alt="category.iconDescription"
          />
        </template>
        <template #title> {{ category.name }} </template>
      </FeedCard>
    </div>
  </div>
</template>
<script setup lang="ts">
import FeedCard from "./FeedCard.vue";
import { useCategoryStore } from "../../../store/v2/category.js";
import { useRouter } from "vue-router";

const categoryStore = useCategoryStore();
const categories = ref([]);
const router = useRouter();

onMounted(async () => {
  categories.value = await categoryStore.getCategories();
});

const navigateToCategory = (id: string | number, name: string) => {
  router.push({
    name: "articlesByCategory",
    params: { category: id, name: name },
  });
};
</script>
